import React, { useState, useContext } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/Drivers/DriverSetting/DriverTopup.css';
import DriverSettingsMasterLayout from '../../../layouts/Drivers/DriverSettingsMasterLayout';
import axios from "axios";
import AppContext from "../../../context/AppContext";


const DriverTopup = () => {
    const navigate = useNavigate();
    const { baseUrl, authToken } = useContext(AppContext);
    const [amount, setAmount] = useState("");
    const [screenshot, setScreenshot] = useState(null);
    const [screenshotPreview, setScreenshotPreview] = useState(null);
    const [showSuccess, setShowSuccess] = useState(false);
    const [errors, setErrors] = useState({});

    // Company Bank Details
    const bankDetails = {
        bankName: 'Meezan Bank',
        accountTitle: 'Trustidrive Pakistan',
        accountNumber: '0123-4567-8901-2345',
        iban: 'PK47MEZN0001234567890123',
        branchCode: '0123'
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (!file.type.startsWith('image/')) {
                setErrors({ ...errors, screenshot: 'Please upload an image file only' });
                return;
            }
            if (file.size > 5 * 1024 * 1024) {
                setErrors({ ...errors, screenshot: 'File size should not exceed 5MB' });
                return;
            }
            setScreenshot(file);
            const reader = new FileReader();
            reader.onloadend = () => setScreenshotPreview(reader.result);
            reader.readAsDataURL(file);
        }
    };
    const removeScreenshot = () => {
        setScreenshot(null);
        setScreenshotPreview(null);
        const input = document.getElementById('screenshot-upload');
        if (input) input.value = '';
    };
    const validateForm = () => {
        const newErrors = {};
        if (!amount || amount <= 0) newErrors.amount = 'Please enter a valid amount';
        if (!screenshot) newErrors.screenshot = 'Please upload transaction screenshot';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const data = new FormData();
        data.append("amount", parseInt(amount));
        data.append("image", screenshot);
        data.append("status", "pending");

        axios.post(`${baseUrl}/driver/topup/createTopup`, data, {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        }).then((response) => {
            console.log("Topup Response:", response.data);
            if (response.data.success === true) {
                setShowSuccess(true);
                setTimeout(() => {
                    setAmount("");
                    setScreenshot(null);
                    setScreenshotPreview(null);
                    setShowSuccess(false);
                    navigate('/driver-mywallet');
                }, 2000);
            }
        }).catch((error) => {
            console.log(error);
            alert("Network Error! Please try again.");
        });
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        // You can add a toast notification here
        alert('Copied to clipboard!');
    };

    return (
        <DriverSettingsMasterLayout screenName={"Topup"} centered={true}>
            <div className="driver-topup-page">
                <Container className="py-4">

                    {/* Success Alert */}
                    {showSuccess && (
                        <Alert variant="success" className="mb-4">
                            <strong>Success!</strong> Your top-up request has been submitted successfully.
                            It will be reviewed shortly.
                        </Alert>
                    )}

                    {/* Bank Details Card */}
                    <Row className="mb-4">
                        <Col lg={8} className="mx-auto">
                            <Card className="bank-details-card">
                                <Card.Body>
                                    <div className="text-center mb-4">
                                        <div className="bank-icon">🏦</div>
                                        <h4 className="mt-3 mb-1">Company Bank Details</h4>
                                        <p className="text-muted">Transfer funds to this account</p>
                                    </div>

                                    <div className="bank-info">
                                        <div className="bank-info-row">
                                            <span className="label">Bank Name:</span>
                                            <div className="value-with-copy">
                                                <span className="value">{bankDetails.bankName}</span>
                                                <button
                                                    className="copy-btn"
                                                    onClick={() => copyToClipboard(bankDetails.bankName)}
                                                >
                                                    📋
                                                </button>
                                            </div>
                                        </div>

                                        <div className="bank-info-row">
                                            <span className="label">Account Title:</span>
                                            <div className="value-with-copy">
                                                <span className="value">{bankDetails.accountTitle}</span>
                                                <button
                                                    className="copy-btn"
                                                    onClick={() => copyToClipboard(bankDetails.accountTitle)}
                                                >
                                                    📋
                                                </button>
                                            </div>
                                        </div>

                                        <div className="bank-info-row">
                                            <span className="label">Account Number:</span>
                                            <div className="value-with-copy">
                                                <span className="value">{bankDetails.accountNumber}</span>
                                                <button
                                                    className="copy-btn"
                                                    onClick={() => copyToClipboard(bankDetails.accountNumber)}
                                                >
                                                    📋
                                                </button>
                                            </div>
                                        </div>

                                        <div className="bank-info-row">
                                            <span className="label">IBAN:</span>
                                            <div className="value-with-copy">
                                                <span className="value">{bankDetails.iban}</span>
                                                <button
                                                    className="copy-btn"
                                                    onClick={() => copyToClipboard(bankDetails.iban)}
                                                >
                                                    📋
                                                </button>
                                            </div>
                                        </div>

                                        <div className="bank-info-row">
                                            <span className="label">Branch Code:</span>
                                            <div className="value-with-copy">
                                                <span className="value">{bankDetails.branchCode}</span>
                                                <button
                                                    className="copy-btn"
                                                    onClick={() => copyToClipboard(bankDetails.branchCode)}
                                                >
                                                    📋
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <Alert variant="info" className="mt-4 mb-0">
                                        <small>
                                            <strong>Note:</strong> Please transfer the exact amount and upload the
                                            transaction screenshot for verification.
                                        </small>
                                    </Alert>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* Top-up Form */}
                    <Row>
                        <Col lg={8} className="mx-auto">
                            <Card className="topup-form-card">
                                <Card.Body>
                                    <h5 className="mb-4">Submit Transaction Details</h5>

                                    <Form onSubmit={handleSubmit}>
                                        {/* Amount Input */}
                                        <Form.Group className="mb-4">
                                            <Form.Label>Amount (PKR)</Form.Label>
                                            <div className="amount-input-wrapper">
                                                <span className="currency-symbol">Rs</span>
                                                <Form.Control
                                                    type="number"
                                                    name="amount"
                                                    placeholder="Enter amount"
                                                    value={amount}
                                                    onChange={(e) => setAmount(e.target.value)}
                                                    className={`amount-input ${errors.amount ? 'is-invalid' : ''}`}
                                                    min="1"
                                                    step="1"
                                                    onKeyDown={(e) => {
                                                        if (e.key === '.' || e.key === ',') e.preventDefault();
                                                    }}
                                                />
                                            </div>
                                            {errors.amount && (
                                                <Form.Text className="text-danger">{errors.amount}</Form.Text>
                                            )}
                                        </Form.Group>

                                        {/* Screenshot Upload */}
                                        <Form.Group className="mb-4">
                                            <Form.Label>Upload Transaction Screenshot</Form.Label>

                                            {!screenshotPreview ? (
                                                <div
                                                    className={`upload-area ${errors.screenshot ? 'error' : ''}`}
                                                    onClick={() => document.getElementById('screenshot-upload').click()}
                                                >
                                                    <div className="upload-icon">📸</div>
                                                    <p className="upload-text">Click to upload screenshot</p>
                                                    <small className="text-muted">
                                                        Supported formats: JPG, PNG (Max 5MB)
                                                    </small>
                                                    <input
                                                        id="screenshot-upload"
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={handleFileUpload}
                                                        style={{ display: 'none' }}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="screenshot-preview">
                                                    <img src={screenshotPreview} alt="Transaction Screenshot" />
                                                    <button
                                                        type="button"
                                                        className="remove-screenshot-btn"
                                                        onClick={removeScreenshot}
                                                    >
                                                        ✕ Remove
                                                    </button>
                                                </div>
                                            )}

                                            {errors.screenshot && (
                                                <Form.Text className="text-danger">{errors.screenshot}</Form.Text>
                                            )}
                                        </Form.Group>

                                        {/* Submit Button */}
                                        <Button
                                            type="submit"
                                            className="submit-btn w-100"
                                            style={{ backgroundColor: '#1B9B82', border: 'none' }}
                                        >
                                            Submit Top-up Request
                                        </Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </DriverSettingsMasterLayout>

    );
};

export default DriverTopup;